export default {
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.updateTitle();
      },
    },
  },
  created() {
    this.updateTitle();
  },
  methods: {
    /**
     * update the tab title based on $pageTitle property of the component
     */

    updateTitle() {
      const getTitle = (vm) => {
        const { $pageTitle } = vm;
        if ($pageTitle) {
          return typeof $pageTitle === "function"
            ? $pageTitle.call(vm)
            : $pageTitle;
        }
      };
      const pageTitle = getTitle(this);
      if (pageTitle) {
        document.title = pageTitle;
      }
    },
  },
};
